import { Component, ElementRef, HostListener } from '@angular/core';
import { EngineIconComponent } from '../../../@icons/engine-icon.component';
import { LogoutIconComponent } from '../../../@icons/logout-icon.component';
import { TranslateModule } from '@ngx-translate/core';
import RoutesConstants from '../../../@commons/constants/routes.constants';
import { AuthApi } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/sdk/auth/auth.api';
import { Router } from '@angular/router';
import { NgClass } from '@angular/common';
import { environment } from '../../../../environments/environment';
import { StorageService } from '../../../@commons/@services/front/storage.service';

@Component({
  selector: 'vw-settings-button',
  imports: [EngineIconComponent, LogoutIconComponent, TranslateModule, NgClass],
  templateUrl: './settings-button.component.html',
  styleUrl: './settings-button.component.scss',
  providers: [
    {
      provide: AuthApi,
      useClass: AuthApi,
    },
    {
      provide: StorageService,
      useClass: StorageService,
    },
  ],
})
export class SettingsButtonComponent {
  showDropdown: boolean = false;
  constructor(
    private authApi: AuthApi,
    private router: Router,
    private eRef: ElementRef,
    private storageService: StorageService,
  ) {
    //get email from
  }

  @HostListener('document:click', ['$event'])
  clickOut(event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.showDropdown = false;
    }
  }

  logout() {
    this.authApi.logout();
    this.storageService.removeItem(environment.ACCESS_TOKEN);
    this.storageService.removeItem(environment.REFRESH_TOKEN);
    this.storageService.removeItem(environment.GUEST_UID);
    this.storageService.removeItem(environment.GUEST_EMAIL);
    this.storageService.removeItem('address-uid');
    this.router.navigate([RoutesConstants.INIT]);
  }
}
